import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function PrivacyPolicy({ onClose }) {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsAnimating(true), 10);
  }, []);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  return (
    <>
      {/* BACKDROP */}
      <div
        className={`fixed inset-0 bg-black z-50 transition-opacity duration-300 ease-out ${
          isAnimating ? "opacity-50" : "opacity-0"
        }`}
        onClick={handleClose}
      />

      {/* MODAL WRAPPER */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        
        {/* MODAL BOX */}
        <div
          className={`bg-white w-full max-w-md rounded-lg shadow-2xl pointer-events-auto transform transition-all duration-300 ease-out ${
            isAnimating
              ? "scale-100 opacity-100 translate-y-0"
              : "scale-90 opacity-0 translate-y-4"
          }`}
        >
          {/* HEADER */}
          <div className="p-6 border-b flex justify-between items-center">
            <h2 className="text-lg font-medium">Privacy Policy</h2>
            <button onClick={handleClose} className="hover:opacity-60 transition">
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* CONTENT */}
          <div
            className="p-6 text-sm text-gray-700 leading-6 space-y-4 max-h-[60vh] overflow-y-auto"
            style={{
              opacity: isAnimating ? 1 : 0,
              transform: isAnimating ? "translateY(0)" : "translateY(10px)",
              transitionDelay: "100ms",
            }}
          >
            <p>
              At ZipNZip, we respect your privacy and are committed to protecting your personal information.
            </p>

            <p>
              We may collect basic details such as your name, email, phone number, and delivery address to process your orders and provide a smooth shopping experience.
            </p>

            <p>
              Payments are securely handled through trusted third-party providers like Razorpay. We do not store your card or payment details on our servers.
            </p>

            <p>
              We may use your information to improve our services, send order updates, and enhance your experience on our platform.
            </p>

            <p>
              Your data may be shared with delivery partners, payment gateways, and analytics services only when necessary to operate our business.
            </p>

            <p>
              We implement reasonable security measures to protect your data, but no method of transmission over the internet is completely secure.
            </p>

            <p>
              You have the right to request access, correction, or deletion of your personal data at any time.
            </p>

            <p>
              By using ZipNZip, you agree to this Privacy Policy.
            </p>

            <button
              onClick={handleClose}
              className="mt-4 w-full bg-black text-white py-2 rounded hover:bg-gray-800 transition"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
}